import { createSlice } from '@reduxjs/toolkit';
import { Lang } from 'types/globalTypes';

interface LangState {
  currentLang: Lang;
}

const initialState: LangState = {
  currentLang: (localStorage.getItem('language') as Lang) || 'en',
};

const langSlice = createSlice({
  name: 'lang',
  initialState,
  reducers: {
    setLang(state, action) {
      state.currentLang = action.payload;
      localStorage.setItem('language', action.payload);
    },
  },
});

export const { setLang } = langSlice.actions;
export default langSlice.reducer;
